import styled from 'styled-components';

const LabelTitleComment = styled.label`
  font-size: 24px;
  font-weight: lighter;
`;

export default LabelTitleComment;
